import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import PermissionPolicyId = com.eidu.entity.permission.PermissionPolicyId

export type DeletePermissionPolicyParameters = {
  id: PermissionPolicyId
}

const deletePermissionPolicy = async ({ id }: DeletePermissionPolicyParameters): Promise<void> => {
  return fetchAuthorized(
    (authContext) =>
      `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/policies/${id.toString()}`,
    { method: 'DELETE' }
  ).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from deletePermissionPolicy endpoint`)
  })
}

export default deletePermissionPolicy
